export default __webpack_public_path__ + "static/media/twitter.6285e385.svg";